export const isVideoFile = (filePath) =>
    /\.(mp4|mov|webm|avi|mkv|m4v|ogg|wmv)$/i.test(filePath || '');

export const isPdfFile = (filePath) =>
    /\.pdf$/i.test(filePath || '');

export const isImageFile = (filePath) =>
    /\.(jpg|jpeg|png|gif|bmp|webp|svg|heic|heif|tiff|tif)$/i.test(filePath || '');

export const getFileNameFromPath = (filePath) =>
    (filePath || '').split('/').pop() || 'document.pdf';

export const getMediaTypeFromPath = (filePath) => {
    if (isVideoFile(filePath)) return 'video';
    if (isPdfFile(filePath)) return 'pdf';
    return 'image';
};

export const isImageFileObject = (file) =>
    file?.type?.startsWith('image/');

export const isVideoFileObject = (file) => {
    if (!file) return false;
    const videoExt = /\.(mp4|mov|webm|avi|mkv|m4v|ogg|wmv)$/i;
    return file.type.startsWith('video/') || videoExt.test(file.name);
};

export const isPdfFileObject = (file) => {
    if (!file) return false;
    return file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
};

export const isAllowedMediaFile = (file) =>
    isImageFileObject(file) || isVideoFileObject(file) || isPdfFileObject(file);
